import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  FormattedMessage,
  FormattedHTMLMessage,
  IntlProvider,
} from "react-intl";
import { history } from "../helper/History";
import Carousel from "react-bootstrap/Carousel";
import ScrollIntoView from "react-scroll-into-view";

class coachingOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: null,
      roles: [],
    };
  }

  componentDidMount() {
    //const { state } = this.props.location;
    //console.log('Inside Didmount --> '+JSON.stringify(this.props.location)+' -- '+this.props.location.state.from);
    // this.scrollToBottom();
    if (typeof this.props.location.state === "object") {
      // check if type is object
      if (this.props.location.state.from === "home") {
        // check if state.from is home open happiness modal
        $("#happiness").modal(); // show model if it comes from home
      }
    }
  }
  // componentDidUpdate() {
  //   this.scrollToBottom();
  // }

  // scrollToBottom() {
  //   this.el.scrollIntoView({ behavior: 'smooth' });
  // }

  openHappiness() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/happiness");
  }
  openTalent() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/talent");
  }
  openTarget() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/target");
  }
  openSale() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/sale");
  }
  openFranchise() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/franchise");
  }
  openCreation() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/creation");
  }
  buyNowTest() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/buy-test");
  }

  // open exmplease function
  openHappinessExamples() {
    let lang = this.props.lang;
    const startButtonText1 =
      this.props.lang === "en"
        ? "Start MyHappiness Test"
        : "Démarrer MyHappiness Test";
    const startButtonText2 = this.props.lang === "en" ? "" : "";
    //console.log(lang);
    // "Totally FREE (First signed)" : "Gratuit (première connexion)"
    $(".pilotModal").modal("hide");
    //console.log('loggedIn '+this.props.isSignedIn);
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Happiness Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualHappinessResult_" + lang + ".png"
      ); // added happiness example image
      // Add start button below examples
      const happinessButton = (
        <div>
          <div>
            <button
              onClick={this.openHappiness.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText1}
              <br />
              <div className="small">{startButtonText2}</div>
              {/* <FormattedHTMLMessage id="ind.happiness.start.example.button" defaultMessage='Start MyHappiness Test<br /><div className="small">Totally FREE (First signed)</div>'/> */}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(
        <IntlProvider locale={lang}>{happinessButton}</IntlProvider>,
        document.getElementById("startButton")
      );
      $("#myModal").modal("show");
    }
  }

  openTalentExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyTalent Test"
        : "Démarrer MyTalent Test";

    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Talent Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualTalentResult_" + lang + ".png"
      );
      // Add start button below examples
      const talentButton = (
        <div>
          <div>
            <button
              onClick={this.openTalent.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(talentButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }

  openTargetExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyTarget Test"
        : "Démarrer MyTarget Test";

    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Target Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualTargetResult_" + lang + ".png"
      );
      // Add start button below examples
      const targetButton = (
        <div>
          <div>
            <button
              onClick={this.openTarget.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(targetButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }
  openSaleExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en" ? "Start MySales Test" : "Démarrer MySales Test";

    //console.log('Inside openSaleExamples');
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //console.log('Inside else');
      //$("#exampleResultTitle").text("Sale Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualSaleResult_" + lang + ".png"
      );
      // Add start button below examples
      const saleButton = (
        <div>
          <div>
            <button
              onClick={this.openSale.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(saleButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }
  openCreationExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyCreation Test"
        : "Démarrer MyCreation Test";
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Creation Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualCreationResult_" + lang + ".png"
      );
      // Add start button below examples
      const entrepreneurButton = (
        <div>
          <div>
            <button
              onClick={this.openCreation.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(
        entrepreneurButton,
        document.getElementById("startButton")
      );
      $("#myModal").modal("show");
    }
  }
  openFranchiseExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyFranchise Test"
        : "Démarrer MyFranchise Test";
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Franchise Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/IndividualFranchiseResult_" + lang + ".png"
      );
      // Add start button below examples
      const franchiseButton = (
        <div>
          <div>
            <button
              onClick={this.openFranchise.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(franchiseButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }

  handleClick() {
    const price = "hr-audit";
    const element = document.getElementById(price);
    console.log(element);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section

      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  render() {
    //let CopyrightDate =  new Date();
    return (
      <React.Fragment>
        <section>
          <div className="col-md-12 d-flex p-0">
            <Carousel id="slider-main" className="individual-slider">
              <Carousel.Item>
                <img
                  className="d-block w-100 bg"
                  src="assets/images/individual-123.jpg"
                  style={{ objectFit: "cover" }}
                  alt="First slide"
                />
                <Carousel.Caption className="text-left d-flex h-100 align-items-center justify-content-center">
                  <div className="intro_layers text-center">
                    {/* <div className="intro_layer mt-3" data-animation="fadeIn">
                      <div className="d-inline-block animate animated bounce">
                        <button
                          type="button"
                          className="btn btn-outline-maincolor center-block"
                          data-animation="fadeIn" data-toggle="modal" data-target="#indivisualContactUs"
                        >
                          ACCESS TO AN EXAMPLE OF PROFILE
                          <br />
                          <div className="small">
                          LEAVE YOUR EMAIL
                          </div>
                        </button>

                      </div>
                    </div>                     */}

                    <div
                      className="intro_layer animate animated fadeFromTop "
                      data-animation="fadeInLeft"
                      style={{
                        backgroundColor: "#18B6CE",
                        color: "white",
                        padding: "20px",
                      }}
                    >
                      {/* <h4 className="text-uppercase intro_featured_word mb-2 mt-4"> */}

                      {/* </h4> */}
                      <p className="text-uppercase intro_featured_word mb-2 mt-4">
                        <b>
                          <FormattedHTMLMessage
                            id="hr.audit.heading1"
                            defaultMessage="TESTS FOR INDIVIDUAL"
                          />
                        </b>
                      </p>
                      <p className="text-left">
                        {" "}
                        <FormattedHTMLMessage
                          id="hr.audit.ul"
                          defaultMessage="12 months"
                        />{" "}
                      </p>
                    </div>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </section>
        <div className="">
          <Link to="/youareacompany">
            <div
              className="white-btns hr-audit-btn"
              style={{
                backgroundColor: "#003366",
                color: "white",
                borderRadius: "5px",
              }}
            >
              <div>
                <FormattedHTMLMessage
                  id="home.titleButton1"
                  defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                />
              </div>
            </div>
          </Link>
          <Link to="/contact-professional">
            <div
              className="white-btns"
              style={{
                backgroundColor: "#003366",
                color: "white",
                borderRadius: "5px",
              }}
            >
              <div>
                <FormattedHTMLMessage
                  id="hrsupport.test.btn.content"
                  defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                />
              </div>
            </div>
          </Link>

          <ScrollIntoView selector="#hraudit">
            <Link style={{ color: "white" }} to="#">
              <button
                className="white-btn"
                style={{
                  backgroundColor: "#003366",
                  color: "white",
                  border: "none",
                  marginTop: "4%",
                  borderRadius: "5px",
                }}
              >
                <FormattedHTMLMessage
                  id="tarifs"
                  defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                />
              </button>
            </Link>
          </ScrollIntoView>
        </div>

        <section className="individual-test" id="hr-audit-block" style={{ bottom:"180px" }}>
          <div className="container-fluid p-0">
            <div className="intro_layer" data-animation="fadeIn">
              <div className="d-block">
                <div className="indi-tests">
                  <ul className="services-list">
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-animation="fadeIn"
                        data-toggle="modal"
                        data-target="#hr"
                        className="btn"
                      >
                        {/* <img src="assets/images/smile-1.png" alt="" /> */}
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="hr.audit.card1"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="hr.audit.card1.sub"
                          defaultMessage="TEST"
                        />
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#happiness"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="hr.audit.card2"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="hr.audit.card2.sub"
                          defaultMessage="TEST"
                        />
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#sale"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="hr.audit.card3"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="hr.audit.card3.sub"
                          defaultMessage="TEST"
                        />
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#enterprise"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="hr.audit.card4"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="hr.audit.card4.sub"
                          defaultMessage="TEST"
                        />
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#open"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="hr.audit.card5"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        <FormattedHTMLMessage
                          id="hr.audit.card5.sub"
                          defaultMessage="TEST"
                        />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="icon-boxed1 audit-boxes teaser-box mt-10"
          id="hraudit"
        >
          <div className="container">
            <div className="row hr-audit-page">
              <p className="text-center w-100 ">
                <FormattedHTMLMessage
                  id="hr.audit.subs.head1"
                  defaultMessage="All subscriptions provide access to all tools and can be recharged with credits at any time."
                />
              </p>

              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box audit-block text-center hero-bg box-shadow">
                  <div>
                    <p>
                      {/* <Link to="/" className=""> */}
                      <FormattedHTMLMessage
                        id="hr.audit.subs.desc1"
                        defaultMessage="starter"
                      />
                      {/* </Link> */}
                    </p>

                    <p>
                      <FormattedHTMLMessage
                        id="hr.audit.subs.desc2"
                        defaultMessage="12 months"
                      />
                    </p>

                    <div className="HalfBordr mt-4">
                      <FormattedHTMLMessage
                        id="hr.audit.sub.desc3"
                        defaultMessage="12 months"
                      />

                      <p className="mt-5">
                        <FormattedHTMLMessage
                          id="hr.audit.subs.desc4"
                          defaultMessage="12 months"
                        />
                      </p>
                    </div>
                    <p className="mt-4">
                      <FormattedHTMLMessage
                        id="hr.audit.sub.desc5"
                        defaultMessage="12 months"
                      />
                    </p>
                  </div>
                  {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none",marginTop:"50px"}}><FormattedHTMLMessage id="coach.offer.subs.btn1" defaultMessage="Subscribe"/></button></Link></div> */}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box audit-block text-center hero-bg box-shadow">
                  <div class="width-add">
                    <p>
                      <FormattedHTMLMessage
                        id="hr.audit.subs.head2"
                        defaultMessage="Classic"
                      />
                    </p>

                    <p>
                      <FormattedHTMLMessage
                        id="hr.audit.subs.desc3"
                        defaultMessage="€49.90"
                      />
                    </p>
                    {/* <p>
                     <FormattedHTMLMessage
                      id="hr.audit.sub.desc4"
                      defaultMessage="per month - annual payment"
                    />
                    </p> */}

                    <div className="HalfBordr mt-4">
                      <FormattedHTMLMessage
                        id="hr.audit.sub.price"
                        defaultMessage="per month - annual payment"
                      />

                      <p className="mt-2">
                        <FormattedHTMLMessage
                          id="hr.audit.sub.desc9"
                          defaultMessage="per month - annual payment"
                        />
                      </p>
                    </div>
                    <div className="HalfBordr mt-4">
                      {/* <FormattedHTMLMessage
                        id="hr.audit.sub.desc6"
                        defaultMessage="per month - annual payment"
                      /> */}

                      <p className="mt-3">
                        <FormattedHTMLMessage
                          id="hr.audit.sub.desc8"
                          defaultMessage="per month - annual payment"
                        />
                      </p>
                    </div>
                    <p className="mt-4">
                      <FormattedHTMLMessage
                        id="hr.audit.sub.desc10"
                        defaultMessage="per month - annual payment"
                      />
                    </p>

                    {/* <p><FormattedHTMLMessage id="Starter.user" defaultMessage="1 user" /></p>    */}
                  </div>
                  {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none"}}><FormattedHTMLMessage id="coach.offer.subs.btn2" defaultMessage="Subscribe"/></button></Link></div> */}
                </div>
              </div>

              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box audit-block text-center hero-bg box-shadow ">
                  <div class="width-add">
                    <h3>
                      <FormattedHTMLMessage
                        id="hr.audit.fullass"
                        defaultMessage="Classic"
                      />
                    </h3>

                    <p className="mt-2">
                      <FormattedHTMLMessage
                        id="hr.audit.fullass.sub"
                        defaultMessage="€49.90"
                      />
                    </p>
                    <div className="HalfBordr mt-5">
                      <FormattedHTMLMessage
                        id="hr.audit.fullass.sub2"
                        defaultMessage="per month - annual payment"
                      />

                      <p className="mt-4">
                        <FormattedHTMLMessage
                          id="hr.audit.fullass.sub3"
                          defaultMessage="per month - annual payment"
                        />
                      </p>
                    </div>

                    <p className="mt-4">
                      <FormattedHTMLMessage
                        id="hr.audit.fullass.sub4"
                        defaultMessage="per month - annual payment"
                      />
                    </p>

                    {/* <p><FormattedHTMLMessage id="Starter.user" defaultMessage="1 user" /></p>    */}
                  </div>
                  {/* <div style={{marginTop:'50px'}}><Link to="/buy-test" className="nav-link"  data-target=".navbar-collapse.show"><button class="btn btn-primary" style={{background:"#18B6CE",border:"none"}}><FormattedHTMLMessage id="coach.offer.subs.btn2" defaultMessage="Subscribe"/></button></Link></div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className="modal fade pilotModal"
          id="myModal"
          // data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  <FormattedMessage
                    id="result.example.title"
                    defaultMessage="Example of Results"
                  />
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                {/* <h5 className="text-center mb-4" id="exampleResultTitle">Happiness Test Results</h5> */}
                <img
                  src="assets/images/happinessResult.png"
                  className="img-fluid w-100"
                  id="testResultData"
                  alt="Happiness Test Result"
                />
                <div className="d-table m-auto">
                  <div className="d-inline-block" id="startButton"></div>
                </div>
                {/* <div className="text-center p-0 small">
                    <p> © Copyright 5W PILOT RH SOLUTIONS {CopyrightDate.getFullYear()} – All right reserved – www.pilotrhsolutions.com.</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade pilotModal"
          id="happiness"
          // data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  MyHappiness Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className="text-justify">
                      <div
                        className="animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ent.happiness.popup.title"
                            defaultMessage="MyHappiness Test: Measure your job happiness."
                          />
                        </h2>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.happiness.popup.about"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.happiness.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.happiness.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your satisfaction at work compare to the average.</li><li> Your satisfaction on eight key factors of balance and development at work.{' '}</li><li>What you can still improved to be happier. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.happiness.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Prepare a professional interview. </li><li> Identify reasons of a possible malaise or weariness. </li><li>Decide on internal ot external mobility. </li></ul>"
                        />
                      </div>

                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.happiness.p.research"  defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF HAPPINESS AT WORK : </p><p class='pl-3'> Business life brings people together to ensure the best possible performance. Some of conditions must be met for everyone to flourish. </p><p class='pl-3'> <b class='title_italic'>MyHAPPINESS TEST©</b> highlights your level of happiness in your job through eight factors of balance and development at work : Freedom of exchange, Possibility of expressing one's wishes, Personal action, Career follow-up, Possibility of working at one's own rate, Accomplishment of a work of freedom, identity, and purpose in your work. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> SAINSAULIEU Renaud. <i>Identité au travail</i>. Paris. Ed. Presse de la Fondation des Sciences Politiques. 1988.. </p>"/>
                      </div> */}
                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.happiness.p.start.test"  defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘My HAPPINESS test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"/>
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openHappinessExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                              <FormattedHTMLMessage id="ind.happiness.btn.examples" defaultMessage="SEE EXAMPLE OF RESULTS"/>
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openHappiness.bind(this)}
                                className="btn bg-info text-white center-block start_button_radius"
                                style={{border: "4px solid red"}}
                              >
                                <FormattedHTMLMessage id="ind.happiness.btn.start"  defaultMessage="Start MyHappiness Test <br/> <div class='small'> Totally FREE (First signed) </div>"/>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.happiness.price" defaultMessage="<h3 class=''>Price </h3>"/>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                      {/* <div className="card-body"> */}
                      {/* <h4 className="card-title">
                                  <FormattedHTMLMessage id="per.test" defaultMessage="Per Test"/>
                                </h4>
                                <p className="card-text"><i>MyHAPPINESS TEST©</i></p> */}
                      {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                      {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedHTMLMessage id="ind.happiness.btn.first.signed" defaultMessage="Start Buy Now"/> */}
                      {/* FREE <small>(First Signed)</small> */}
                      {/* </button> */}
                      {/* </div> */}
                      {/* </div>
                          </div>
                        </div>
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail1" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                      </div> */}
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-table m-auto">
                          <div className="d-inline-block flex-fill">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block"
                                data-animation="fadeIn"
                                style={{
                                  backgroundColor: "#003366",
                                  color: "white",
                                }}
                              >
                                <Link
                                  target="_blank"
                                  className="text-white"
                                  to="/contact-enterprise"
                                >
                                  <FormattedHTMLMessage
                                    id="hrsupport.test.btn.content"
                                    defaultMessage="<span>CONTACT US</span>  <div class=''> FOR A PRIVATE DEMONSTRATION </div><br/> (Enterprise ONLY)"
                                  />
                                </Link>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="talent">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyTALENT Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className="animate animated slideInLeft"
                        data-animation="slideInRight"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.talent.popup.title"
                            defaultMessage="MyTALENT Test :<br /> &amp; Identify your natural talents"
                          />
                        </h2>
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your stong engines and personal work practice. </li><li> What you do with the greatest ease and less fatigue. </li><li>Your communication skills.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your stong engines and personal work practice.
                          </li>
                          <li>
                            What you do with the greatest ease and less fatigue.
                          </li>
                          <li>Your communication skills.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Know your talents and strong points.</li><li>Make a quick professional report.</li><li>Find your way of excellence.</li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                        <ul className="indi-ul">
                          <li>Know your talents and strong points.</li>
                          <li>Make a quick professional report.</li>
                          <li>Find your way of excellence.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'>MEASURE OF PERSONALITY :</p><p class='pl-3'> Each person approaches the world differently. Some of them by the concrete and operational approach the others by the abstract and functional approach. Well understand how everybody works help to accept differences between individuals. </p><p class='pl-3'> MyTALENT Test highlights range of professions which are you natural for the candidate and what are his/her best talents (Manager/organizer; Inventor/engineer Doer; Communicator). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (The man discovering his soul C.G. Jung - 1963). </p><p class='modal-text'>MEASURE OF MOTIVATIONS:</p><p class='pl-3'> Each person has career anchors or dominant motivational traits that last a lifetime and that can be relied on by the person to build a career </p><p class='pl-3'> MyTALENT Test allows the candidate to prioritize and reveal their motivational preferences (Leadership, service to others, challenge, safety, balance of life, entrepreneurial spirit, autonomy, expertise). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Career Anchors - E. Schein - 1996 - Last edition 2013). </p><p class='modal-text'> MEASURE OF COMMUNICATION STYLE: </p><p class='pl-3'> Emotions leave a strong mark on the personality (fear, anger, sadness, joy). . Often a taboo topic, feelings are not always well understood. The ability to manage one's feelings and those of others increases communication and persuasion skills. </p><p class='pl-3'> MyTALENT Test allows the candidate to reveal his/her level of communication and what could be still improve in the seven skills of Emotional Quotient (E.Q.) : awareness of feelings, ability to share emotion, ability to live in a group, ability to convey emotion with a group, ability to listen to others, confidence to live with emotion, freedom to follow emotion. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (L’intelligence du coeur – I. Filliozat – 1995. Last edition 2013 - Paris Ed. JC Lattès) </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">MEASURE OF PERSONALITY :</p>
                        <p className="pl-3">
                          Each person approaches the world differently. Some of them by the concrete and operational approach the others by the abstract and functional approach. Well understand how everybody works help to accept differences between individuals.
                        </p>
                        <p className="pl-3">
                          MyTALENT Test highlights range of professions which are you natural for the candidate and what are his/her best talents (Manager/organizer; Inventor/engineer Doer; Communicator).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (The man discovering his soul C.G. Jung - 1963).
                        </p>
                        <p className="modal-text">MEASURE OF MOTIVATIONS:</p>
                        <p className="pl-3">
                          Each person has career anchors or dominant motivational traits that last a lifetime and that can be relied on by the person to build a career
                        </p>
                        <p className="pl-3">
                          MyTALENT Test allows the candidate to prioritize and reveal their motivational preferences (Leadership, service to others, challenge, safety, balance of life, entrepreneurial spirit, autonomy, expertise).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (Career Anchors - E. Schein - 1996 - Last edition 2013).
                        </p>
                        <p className="modal-text">
                          MEASURE OF COMMUNICATION STYLE:
                        </p>
                        <p className="pl-3">
                          Emotions leave a strong mark on the personality (fear, anger, sadness, joy). . Often a taboo topic, feelings are not always well understood. The ability to manage one's feelings and those of others increases communication and persuasion skills.
                        </p>
                        <p className="pl-3">
                          MyTALENT Test allows the candidate to reveal his/her level of communication and what could be still improve in the seven skills of Emotional Quotient (E.Q.) : awareness of feelings, ability to share emotion, ability to live in a group, ability to convey emotion with a group, ability to listen to others, confidence to live with emotion, freedom to follow emotion.
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (L’intelligence du coeur – I. Filliozat – 1995. Last edition 2013 - Paris Ed. JC Lattès)
                        </p>                         */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyTALENT test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting ‘MyTALENT test’ you can see an
                            example of results exactly as you will get after
                            taking. Results of your test still totally
                            confidential and we don’t use any named data coming
                            from you for other destination of the test (French
                            Data Authority n°661001){" "}
                          </p>
                        </div> */}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openTalentExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                                <FormattedHTMLMessage
                                  id="ind.talent.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn bg-info text-white center-block start_button_radius"
                                  onClick={this.openTalent.bind(this)}
                                  style={{ border: "4px solid red" }}
                                >
                                  <FormattedHTMLMessage
                                    id="ind.talent.btn.start"
                                    defaultMessage="Start MyTALENT Test"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                              {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id='per.test' defaultMessage='Per Test'/>
                                </h4> */}
                              {/* <p className="card-text"><i>MyTALENT TEST©</i></p> */}
                              {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                              <button
                                className="btn btn-warning"
                                style={{
                                  color: "white",
                                  backgroundColor: "#808080",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="ind.talent.buy.now"
                                  defaultMessage="Start Buy Now"
                                />
                              </button>
                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.talent.pice.detail"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                        {/* <ul className="indi-ul">
                          <li>Buy 1 test credit = <b>€ 20</b>/test</li>
                          <li>Buy 2 test credits = <b>€ 13,5</b>/test</li>
                          <li>Buy 3 test credits = <b>€ 12</b>/test</li>
                          <li>Buy 4 test credits and more = <b>€ 10</b>/test</li>
                        </ul> */}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.talent.pice.detail1"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="target">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyTARGET Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideUp"
                        data-animation="slideUp"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.target.popup.title"
                            defaultMessage="MyTARGET Test : <br />&amp; Identify your best place to work"
                          />
                        </h2>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>23 questions - 6 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.resultlist"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Better know you want</li><li> Identify your priority target for looking at a job </li><li>Find your way of excellence. </li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF WORK CONTEXTS :{' '}</p><p class='pl-3'> Each company has a body of rules that makes it belong to different social worlds. </p><p class='pl-3'> MyTARGET Test allows the candidate to check which socio-professional world he feels closest to and where he can best develop (regulatory world, community, professional public service, professional, mobility, entrepreneurial). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> I. Francfort, F. Osty, M. Uhalde (Les mondes sociaux de l’entreprise – Paris 1995 – Ed. Desclée de Brouwer – Last Edition 2007) </p><p class='modal-text'>MEASURE OF WORK CULTURE : </p><p class='pl-3'> Each company has a mix of culture composed by history, actions, relationships, thinking, know-how and people. </p><p class='pl-3'> MyTARGET Test allows the candidate to check what is most important for him/her and suit best with companies. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> C. Hampden-Turner (La culture d’entreprise : des cercles vicieux aux cercles vertueux – Paris 1992 – Ed. du Seuil) </p><p class='modal-text'> MEASURE OF WORK MANAGEMENT : </p><p class='pl-3'> Management approach still very different in Institution, Corporation, Small Business or independent. Each people has his/her own references and habits. </p><p class='pl-3'> MyTARGET Test allows the candidate to sort witch management approach suit best to him or her. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> C. Handy (L’Olympe des Managers – 1992 – Paris - Ed. du Seuil) </p><p class='modal-text'> MEASURE OF WORK ATMOSPHERE : </p><p class='pl-3'> People are more productive if they find the right atmosphere according to their personality. </p><p class='pl-3'> MyTARGET Test allows the candidate to sort with witch people and atmosphere suit best to him or her. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> P. Pitcher (Artistes, Artisans et Technocrates –Paris - 1996– Ed. Village Mondial – Last Edition 2000). </p>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting MyTARGET test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"
                        />

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openTargetExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                                <FormattedHTMLMessage
                                  id="ind.target.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn bg-info text-white center-block start_button_radius"
                                  onClick={this.openTarget.bind(this)}
                                  style={{ border: "4px solid red" }}
                                >
                                  <FormattedHTMLMessage
                                    id="ind.target.btn.start"
                                    defaultMessage="Start MyTARGET Test"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                              <button
                                className="btn btn-warning"
                                style={{
                                  color: "white",
                                  backgroundColor: "#808080",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="ind.talent.buy.now"
                                  defaultMessage="Start Buy Now"
                                />
                              </button>
                              {/* </div> */}
                            </div>
                          </div>
                        </div>

                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.happiness.pice.detail"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.happiness.pice.detail1"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="sale">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MySALES Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideDown"
                        data-animation="slideDown"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ent.sale.popup.title"
                            defaultMessage="MySALES Test :<br /> &amp; Maesure your sale potential"
                          />
                        </h2>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.sale.popup.about"
                          defaultMessage="<h3>Duration</h3><ul class='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.sale.popup.duration"
                          defaultMessage="<h3>Duration</h3><ul class='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.sale.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of sale compare to the average. </li><li> Your potentiel of sale on eight key factors of success of sale </li><li>What you can still improved to sale more.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.sale.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Prepare a professional interview. </li><li> Identify your strong and your weak points to improve. </li><li>Decide to join a sale job.</li></ul>"
                        />
                      </div>

                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.sale.p.research" defaultMessage="<h3 class=''>Scientific-Researches </h3> <p>MEASURE OF SALE POTENTIAL:</p><p> Each people had a potential to sell even if it’s not his/her job or training. In any case it’s very important to know his / her potential and own resources first to sell him of herself. </p><p> MySALES Test allows the candidate to assess himself (herself) on eight keys factors of success to sell (Openness, Listening Skills, Adaptability, Know How, Negotiation Skills, Decision Making, Self-Control, Drive). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Les techniques de la vente – E. Moulinier - Paris 2007 – Ed. Eyrolles) recommend too by D.C.F Association (Dirigeant Commerciaux de France). </p>"/>
                   
                      </div> */}
                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.sale.p.start.test" defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MySALE Test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001) </p>"/>
                      */}

                      {/* <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                             <button
                                onClick={this.openSaleExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                              <FormattedHTMLMessage id="ind.sale.btn.examples" defaultMessage="SEE EXAMPLE OF RESULTS"/>
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn bg-info text-white center-block start_button_radius"
                                  onClick={this.openSale.bind(this)}
                                  style={{border: "4px solid red"}}
                                >
                                <FormattedHTMLMessage id="ind.sale.btn.start" defaultMessage="Start MySALES Test"/>
                                </button>
                              </p>
                            </div>
                          </div>
                        </div> */}
                      {/* </div> */}
                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.sale.price" defaultMessage="<h3 class=''>Price </h3>"/>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                             
                                 <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button>
                              
                            </div>
                          </div>
                        </div>
                        
                      <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail1" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                      </div> */}
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-table m-auto">
                          <div className="d-inline-block flex-fill">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block"
                                data-animation="fadeIn"
                                style={{
                                  backgroundColor: "#003366",
                                  color: "white",
                                }}
                              >
                                <Link
                                  target="_blank"
                                  className="text-white"
                                  to="/contact-enterprise"
                                >
                                  <FormattedHTMLMessage
                                    id="hrsupport.test.btn.content"
                                    defaultMessage="<span>CONTACT US</span>  <div class=''> FOR A PRIVATE DEMONSTRATION </div><br/> (Enterprise ONLY)"
                                  />
                                </Link>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="enterprise">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyCREATION Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ent.creation.popup.title"
                            defaultMessage="MyCREATION Test : <br />Maesure your business creation potential"
                          />
                        </h2>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.creation.popup.about"
                          defaultMessage="<h3>Duration </h3><ul class='indi-ul'><li>40 questions – 7 minutes. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.creation.duration"
                          defaultMessage="<h3>Duration </h3><ul class='indi-ul'><li>40 questions – 7 minutes. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.creation.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of business creation compare to the average. </li><li> Your potentiel of business creation on eight key factors of success </li><li> What you can still improved to be ready to create. </li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ent.creation.help"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> POTENTIAL OF CREATIVITY: </p><p class='pl-3'> Each people has the potential to create even if you don’t plan to start up your own company or work for yourself. In each case it’s very important to know your own potential of creativity and how to take more responsibility in your work.</p><p class='pl-3'> <b class='title_italic'>MyCREATION TEST©</b> allows the candidate to assess himself (herself) based on eight key factors to success to create (Initiative/Creativity, Ambition/Work capability, Ability to manage people, Ability to sell, Organization skills, Business knowledge, Ability to run a business, Personal situation).. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> PAPIN Robert. La création d’entreprise. Paris. Éd. Dunod. 2015. 16ème édition, awarded by HEC (Hautes Études Commerciales de Paris) – High Business School of Management in Paris).</p>"
                        />
                      </div>
                      {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ind.creation.p.start.test" defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyCREATION Test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001){' '}</p>"/>
                       

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                             <button
                                onClick={this.openCreationExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                                <FormattedHTMLMessage id="ind.creation.btn.examples" defaultMessage="SEE EXAMPLE OF RESULTS"/>
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn bg-info text-white center-block start_button_radius"
                                  onClick={this.openCreation.bind(this)}
                                  style={{border: "4px solid red"}}
                                >
                                  <FormattedHTMLMessage id="ind.creation.btn.start" defaultMessage="Start MyCREATION Test"/>
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
            					</div> */}
                      {/* <div className="indi-list">
                        <h3 className=""><FormattedMessage id="price" defaultMessage="Price "/></h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                           
                                 <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button>
                              {/* </div> */}
                      {/* </div>
                          </div>
                        </div>
                   
                      <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.happiness.pice.detail1" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"/>
                      </div> */}
                      <div
                        className="add-width intro_layer mt-5 d-flex"
                        data-animation="fadeIn"
                      >
                        <div className="d-table m-auto">
                          <div className="d-inline-block flex-fill">
                            <p>
                              <button
                                type="button"
                                className="btn  center-block"
                                data-animation="fadeIn"
                                style={{
                                  backgroundColor: "#003366",
                                  color: "white",
                                }}
                              >
                                <Link
                                  target="_blank"
                                  className="text-white"
                                  to="/contact-enterprise"
                                >
                                  <FormattedHTMLMessage
                                    id="hrsupport.test.btn.content"
                                    defaultMessage="<span>CONTACT US</span>  <div class=''> FOR A PRIVATE DEMONSTRATION </div><br/> (Enterprise ONLY)"
                                  />
                                </Link>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="FRANCHISE">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white">
                  MyFRANCHISE Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.franchise.popup.title"
                            defaultMessage="<i>MyFRANCHISE TEST©</i> : <br />Measure your ability to be successful with Franchise"
                          />
                        </h2>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.duration"
                          defaultMessage="<h3>Duration </h3><ul class='indi-ul'><li>40 questions – 7 minutes. </li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of success with a franchise compare to the average.{' '}</li><li> Your adequation with skills and work culture of list of franchising </li><li> What you can still improved to be ready to create in franchise. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF FRANCHISE POTENTIAL : </p><p class='pl-3'> Each people had a potential to create but not alone necessary. Franchise is between having a job and create his/her business. It’s a financial partnership with a wellknown company witch duplicate a successfull concept. </p><p class='pl-3'> MyFRANCHISE Test allows the candidate to assess himself (herself) on eight keys factors of success to be successful in Franchise that is a mix of ability to sell and create (Openness, Adaptability, Decision Making, Ability to manage people, Ability to sell, Organization skills, Ability to run a business, Personal situation). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Devenir franchisé ou lancer une franchise – C. Zimmer - Paris 2011 – 3ème édition Ed. Vuibert) recommended by F.F.F (Fédération Française de la Franchise de Paris). </p>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyFRANCHISE Test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001){' '}</p></div>"
                        />

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openFranchiseExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                              >
                                <FormattedHTMLMessage
                                  id="ind.franchise.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <p>
                                <button
                                  type="button"
                                  className="btn bg-info text-white center-block start_button_radius"
                                  onClick={this.openFranchise.bind(this)}
                                  style={{ border: "4px solid red" }}
                                >
                                  <FormattedHTMLMessage
                                    id="ind.franchise.btn.start"
                                    defaultMessage="Start MyFRANCHISE Test"
                                  />
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        <h3 className="">
                          <FormattedMessage
                            id="price"
                            defaultMessage="Price "
                          />
                        </h3>

                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4">
                              <button
                                className="btn btn-warning"
                                style={{
                                  color: "white",
                                  backgroundColor: "#808080",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedMessage
                                  id="ind.talent.buy.now"
                                  defaultMessage="Start Buy Now"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.happiness.pice.detail"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id="ind.happiness.pice.detail1"
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="hr">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  ENTREPRENEURIAL Assessment Platform
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className="container text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInRight"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ent.hr.popup.title"
                            defaultMessage="BUSINESS CREATION Assessment Platform"
                          />
                        </h2>
                        <div className="about-text">
                          <FormattedHTMLMessage
                            id="ent.hr.popup.about"
                            defaultMessage="<p>You are an enterprise and want to source the right candidate to your company especially on motivations and values waiting for.</p><p><b>The RECRUITMENT Assessment Platform</b> allows in three minutes to each candidate assess his/her potential to fit with the culture and value of the company and fit with skills asked (Organizer, Administrator, Manager, Commercial, Expertise, Listening, Adaptability, Personal situation).</p><p>Moreover enterprise get global statistical results and see per population what the candidate expected more to adapt the recruitment. The platform is customized per company.</p>"
                          />
                        </div>

                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.hr.duration"
                            defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 3 minutes.</li></ul>"
                          />
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.hr.resultlist"
                            defaultMessage="<h3 class=''>Results </h3> <ul className='indi-ul'> <li> Global satisfaction of employees compare to the average of the company. </li><li> Detail of satisfaction on eight key factors of balance and development. </li><li>How company still improved happiness of employees per population.</li></ul>"
                          />
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.hr.help"
                            defaultMessage="<h3 class=''>Help </h3> <ul className='indi-ul'> <li>Practical online test to prepare professional interview.</li><li> Identify malaise of employee or for all company. </li><li> Degrease turn-over of the company </li><li> Have a sample observatory of the well-being in the company </li></ul>"
                          />
                        </div>
                        {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ent.creation.price" defaultMessage="<h3 class=''>Price</h3> <ul className='indi-ul'> <li>Ask for a quote</li></ul>"/>
                      </div>                                  */}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-table m-auto">
                            <div className="d-inline-block flex-fill">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block"
                                  data-animation="fadeIn"
                                  style={{
                                    backgroundColor: "#003366",
                                    color: "white",
                                  }}
                                >
                                  <Link
                                    target="_blank"
                                    className="text-white"
                                    to="/contact-enterprise"
                                  >
                                    <FormattedHTMLMessage
                                      id="hrsupport.test.btn.content"
                                      defaultMessage="<span>CONTACT US</span>  <div class=''> FOR A PRIVATE DEMONSTRATION </div><br/> (Enterprise ONLY)"
                                    />
                                  </Link>
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade pilotModal" id="open">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  OPEN Platform
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className="container text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInRight"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ent.open.popup.title"
                            defaultMessage="BUSINESS CREATION Assessment Platform"
                          />
                        </h2>
                        <div className="about-text">
                          <FormattedHTMLMessage
                            id="ent.open.popup.about"
                            defaultMessage="<p>You are an enterprise and want to source the right candidate to your company especially on motivations and values waiting for.</p><p><b>The RECRUITMENT Assessment Platform</b> allows in three minutes to each candidate assess his/her potential to fit with the culture and value of the company and fit with skills asked (Organizer, Administrator, Manager, Commercial, Expertise, Listening, Adaptability, Personal situation).</p><p>Moreover enterprise get global statistical results and see per population what the candidate expected more to adapt the recruitment. The platform is customized per company.</p>"
                          />
                        </div>

                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.open.duration"
                            defaultMessage=""
                          />
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.open.resultlist"
                            defaultMessage="<h3 class=''>Results </h3> <ul className='indi-ul'> <li> Global satisfaction of employees compare to the average of the company. </li><li> Detail of satisfaction on eight key factors of balance and development. </li><li>How company still improved happiness of employees per population.</li></ul>"
                          />
                        </div>
                        <div className="indi-list">
                          <FormattedHTMLMessage
                            id="ent.open.help"
                            defaultMessage="<h3 class=''>Help </h3> <ul className='indi-ul'> <li>Practical online test to prepare professional interview.</li><li> Identify malaise of employee or for all company. </li><li> Degrease turn-over of the company </li><li> Have a sample observatory of the well-being in the company </li></ul>"
                          />
                        </div>
                        {/* <div className="indi-list">
                        <FormattedHTMLMessage id="ent.creation.price" defaultMessage="<h3 class=''>Price</h3> <ul className='indi-ul'> <li>Ask for a quote</li></ul>"/>
                      </div>                                  */}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-table m-auto">
                            <div className="d-inline-block flex-fill">
                              <p>
                                <button
                                  type="button"
                                  className="btn  center-block"
                                  data-animation="fadeIn"
                                  style={{
                                    backgroundColor: "#003366",
                                    color: "white",
                                  }}
                                >
                                  <Link
                                    target="_blank"
                                    className="text-white"
                                    to="/contact-enterprise"
                                  >
                                    <FormattedHTMLMessage
                                      id="hrsupport.test.btn.content"
                                      defaultMessage="<span>CONTACT US</span>  <div class=''> FOR A PRIVATE DEMONSTRATION </div><br/> (Enterprise ONLY)"
                                    />
                                  </Link>
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    lang: state.locale.lang,
  };
};

coachingOffer = connect(mapStateToProps, {})(coachingOffer);

export default coachingOffer;
